import { atom } from 'jotai'
import { selectAtom } from 'jotai/utils'

export type ActiveToolExecution = {
	feedAd: boolean
	storyAd: boolean
	landingPage: boolean
	form: boolean
}

/**
 * Tracks which campaign resources currently have active chat tool calls executing.
 * This is updated by the chat editor hook and consumed by simulators to show
 * immediate "AI is editing..." feedback without waiting for polling.
 */
export const activeChatToolsAtom = atom<ActiveToolExecution>({
	feedAd: false,
	storyAd: false,
	landingPage: false,
	form: false,
})

/**
 * Tracks which campaign resources currently have active IMAGE tool calls executing.
 * This is separate from text tools so images can pulse independently.
 */
export const activeImageToolsAtom = atom<ActiveToolExecution>({
	feedAd: false,
	storyAd: false,
	landingPage: false,
	form: false,
})

/**
 * Derived atoms for fine-grained subscriptions to individual resource tool states.
 * Components subscribing to these atoms only re-render when their specific resource changes,
 * preventing unnecessary re-renders when other resources' states update.
 */

// Chat tool derived atoms (text-based tools)
export const activeFeedChatToolAtom = selectAtom(activeChatToolsAtom, (v) => v.feedAd)
export const activeStoryChatToolAtom = selectAtom(activeChatToolsAtom, (v) => v.storyAd)
export const activeLandingChatToolAtom = selectAtom(activeChatToolsAtom, (v) => v.landingPage)
export const activeFormChatToolAtom = selectAtom(activeChatToolsAtom, (v) => v.form)

// Image tool derived atoms (separate so images can pulse independently)
export const activeFeedImageToolAtom = selectAtom(activeImageToolsAtom, (v) => v.feedAd)
export const activeStoryImageToolAtom = selectAtom(activeImageToolsAtom, (v) => v.storyAd)
export const activeLandingImageToolAtom = selectAtom(activeImageToolsAtom, (v) => v.landingPage)
export const activeFormImageToolAtom = selectAtom(activeImageToolsAtom, (v) => v.form)
